import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './FeedbackPin.module.scss';

const FeedbackPin = ({ number, x, y, severity }) => (
  <div
    className={cn(styles.pin, styles[severity])}
    style={{
      left: `${x}%`,
      top: `${y}%`,
    }}
  >
    #
    {' '}
    {number}
  </div>
);

FeedbackPin.propTypes = {
  number: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  severity: PropTypes.string,
};

export default FeedbackPin;
